<div class="page-wrapper pt-4">
    <div class="card rounded shadow-lg">
        <div class="dashboard-content">
            <!-- Updated page title and subtitle for CDE -->
            <h1 class="page-title">{{subCounty}}</h1>
            <p class="page-subtitle">
                Educational Oversight & Quality Assurance Management Dashboard
            </p>

            <!-- Updated stats cards with CDE-specific KPIs -->
            <div class="row mb-4">
                <div class="col mb-2">
                    <div class="stat-card h-100 cursor-pointer" (click)="navigateToReview(2)">
                        <i class="fas fa-clipboard-check stat-icon"></i>
                        <div class="stat-number">
                            {{ dashboardDetails?.Data?.INSPECTION_DONE }}
                        </div>
                        <div class="stat-label">INSPECTIONS DONE</div>
                        <div class="stat-sublabel">Completed cycle</div>
                    </div>
                </div>
                <div class="col mb-2">
                    <div class="org-card h-100 cursor-pointer" (click)="navigateToReview(1)">
                        <i class="fas fa-calendar-alt stat-icon"></i>
                        <div class="stat-number">
                            {{ dashboardDetails?.Data?.SCHEDULE_PENDING }}
                        </div>
                        <div class="stat-label">SCHEDULE PENDING</div>
                        <div class="stat-sublabel">Awaiting timeline</div>
                    </div>
                </div>
                <div class="col mb-2">
                    <div class="stat-card h-100 cursor-pointer" (click)="navigateToReview(5)">
                        <i class="fas fa-hourglass-half stat-icon"></i>
                        <div class="stat-number">
                            {{ dashboardDetails?.Data?.UNDER_EVALUATION }}
                        </div>
                        <div class="stat-label">UNDER EVALUATION</div>
                        <div class="stat-sublabel">Active inspections</div>
                    </div>
                </div>
                <div class="col mb-2">
                    <div class="org-card h-100 cursor-pointer" (click)="navigateToReview(4)">
                        <i class="fas fa-edit stat-icon"></i>
                        <div class="stat-number">
                            {{ dashboardDetails?.Data?.RECOMMENDATION_PENDING }}
                        </div>
                        <div class="stat-label">REC. PENDING</div>
                        <div class="stat-sublabel">Review required</div>
                    </div>
                </div>
                <div class="col mb-2">
                    <div class="red-card h-100 cursor-pointer" (click)="navigateToReview(3)">
                        <i class="fas fa-reply stat-icon"></i>
                        <div class="stat-number">
                            {{ dashboardDetails?.Data?.SENDBACK_BY_SCDE }}
                        </div>
                        <div class="stat-label">SENDBACK BY SCDE</div>
                        <div class="stat-sublabel">Requires revision</div>
                    </div>
                </div>
            </div>

            <!-- Charts Row -->
            <div class="row mb-4">
                  <!-- Institution categories pie chart -->
                <div class="col-md-5 mb-2">
                    <div class="chart-card h-100">
                        <div class="chart-header">
                            
                            <div>
                                <div class="chart-title"><i class="fas fa-chart-pie me-2"></i>Institution Type Distribution</div>
                                <!-- <div class="chart-subtitle">
                                    Distribution by institution type
                                </div> -->
                            </div>
                        </div>
                        <div class="chart-body">
                            <div class="pie-chart-container">
                                <div class="pie-chart">
                                    <svg width="200" height="200" viewBox="0 0 200 200">
                                        <!-- Background circle -->
                                        <circle cx="100" cy="100" r="80" fill="none" stroke="#e9ecef"
                                            stroke-width="40" />

                                        <!-- Regular institutions -->
                                        <circle cx="100" cy="100" r="80" fill="none" stroke="#00adee" stroke-width="40"
                                            [attr.stroke-dasharray]="getSegmentLength('Pre-primary') + ' 502.4'" stroke-dashoffset="0" transform="rotate(-90 100 100)" />

                                        <!-- Integrated institutions -->
                                        <circle cx="100" cy="100" r="80" fill="none" stroke="#ffc107" stroke-width="40"
                                            [attr.stroke-dasharray]="getSegmentLength('Junior School') + ' 502.4'" 
                                            [attr.stroke-dashoffset]="'-' + getSegmentLength('Pre-primary')" transform="rotate(-90 100 100)" />

                                        <!-- SNE institutions -->
                                        <circle cx="100" cy="100" r="80" fill="none" stroke="#28a745" stroke-width="40"
                                            [attr.stroke-dasharray]="getSegmentLength('Senior School') + ' 502.4'" 
                                            [attr.stroke-dashoffset]="'-' + (getSegmentLength('Pre-primary') + getSegmentLength('Junior School'))" transform="rotate(-90 100 100)" />
                                    </svg>
                                </div>
                                <div class="pie-legend">
                                    <div class="legend-item">
                                        <span class="legend-color" style="background-color: #00adee"></span>
                                        <span class="legend-label">primary School
                                            ({{dashboardDetails?.institutionType?.PRE_PRIMARY}})</span>
                                        <span class="legend-percent">{{(+dashboardDetails?.institutionType?.PRE_PRIMARY_PERCENTAGE)}}%</span>
                                    </div>
                                    <!-- <div class="legend-item">
                                        <span class="legend-color" style="background-color: #ffc107"></span>
                                        <span class="legend-label">Junior School ({{
                                            dashboardDetails?.institutionType?.JUNIOR_SCHOOL
                                            }})</span>
                                        <span class="legend-percent">{{
                                            (+dashboardDetails?.institutionType?.JUNIOR_SCHOOL_PERCENTAGE)
                                            }}%</span>
                                    </div> -->
                                    <div class="legend-item">
                                        <span class="legend-color" style="background-color: #28a745"></span>
                                        <span class="legend-label">Senior School ({{
                                            dashboardDetails?.institutionType?.SENIOR_SCHOOL
                                            }})</span>
                                        <span class="legend-percent">{{
                                            (+dashboardDetails?.institutionType?.SENIOR_SCHOOL_PERCENTAGE)
                                            }}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Institution approval status breakdown -->
                <div class="col-md-7 mb-2">
                    <div class="chart-card h-100">
                        <div class="chart-header d-flex align-items-center">
                            <i class="fas fa-calendar-days me-2"></i>
                            <div class="d-flex justify-content-between w-100">
                                <div>
                                    <div class="chart-title"><i class="fas fa-calendar-alt me-2"></i>
                                        Upcoming Inspections
                                    </div>
                                </div>
                                <!-- <div class="chart-subtitle d-flex align-items-center gap-2">
                                    <button class="inspections-nav-btn me-2">
                                        <i class="fas fa-chevron-left"></i>
                                    </button>
                                    <span class="inspections-month">May 2024</span>
                                    <button class="inspections-nav-btn ms-2">
                                        <i class="fas fa-chevron-right"></i>
                                    </button>
                                </div> -->
                            </div>
                        </div>
                        <div class="chart-body">
                            <div class="inspections-list">
                                <!-- Inspection Card 1 -->
                                <div class="inspection-card" *ngFor="let item of upcmngInspctnDtls">
                                    <div class="inspection-date inspection-date-primary text-center">
                                        <div class="inspection-day">{{item.INSPECTION_DATE | date: 'dd'}}</div>
                                        <div class="inspection-month">{{item.INSPECTION_DATE | date: 'MMM'}}</div>
                                    </div>
                                    <div class="inspection-details">
                                        <div class="inspection-school">
                                            {{item.TNT_NAME}}
                                        </div>
                                        <div class="inspection-location">
                                            <i class="fas fa-location-dot me-1"></i>
                                            <span>{{item.COUNTIES_NAME}}, {{item.SUB_COUNTIES_NAME}}</span>
                                        </div>
                                    </div>
                                    <div class="inspection-badge badge-new">
                                        NEW
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>              
            </div>

            <!-- Distribution by sub-county row -->
            <div class="row mb-4">
                <div class="col-12">
                    <div class="chart-card h-100">
                        <div class="chart-header d-flex justify-content-between align-items-center">
                            <div>
                                <div class="chart-title">
                                    Past Inspections
                                </div>
                                <div class="chart-subtitle">
                                    Historical records of completed institutional inspections
                                </div>
                            </div>
                            <button class="btn btn-light past-export-btn" (click)="exportPastInspections()" [disabled]="pastInspctnDtls.length === 0">
                                <i class="fas fa-download me-2"></i>
                                Export Data
                            </button>
                        </div>
                        <div class="chart-body past-inspections-body" *ngIf="pastInspctnDtls.length != 0">
                            <table class="past-table mt-1" datatable [dtOptions]="dtOptions">
                                <thead>
                                    <tr class="past-table-header">
                                        <th class="past-col institution">INSTITUTION NAME</th>
                                        <th class="past-col status">COMPLETION STATUS</th>
                                        <!-- <th class="past-col cycle">INSPECTION CYCLE</th> -->
                                        <th class="past-col date">COMPLETION DATE</th>
                                        <th class="past-col actions text-end">ACTIONS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="past-row" *ngFor="let p of pastInspctnDtls">
                                        <td class="past-col institution">
                                            <div class="institution-name">{{p.TNT_NAME}}</div>
                                            <div class="institution-type">{{p.SCHOOLLEVEL_NAME}}</div>
                                        </td>
                                        <td class="past-col status">
                                            <span class="status-badge status-completed">Completed</span>
                                        </td>
                                        <!-- <td class="past-col cycle">
                                            Annual 2023
                                        </td> -->
                                        <td class="past-col date">
                                            {{p.INSPECTION_DATE | date: 'dd MMM yyyy'}}
                                        </td>
                                        <td class="past-col actions text-end" >
                                            <button class="past-action-btn" *ngIf="p?.MULTIPLE_FILE_UPLOADS_DTO.length > 0" data-bs-target="#viewDocModal"
                                                data-bs-toggle="modal"  (click)="viewDocLst = p?.MULTIPLE_FILE_UPLOADS_DTO">
                                                <i class="fas fa-eye"></i>
                                            </button>
                                        </td>   
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="text-center" *ngIf="!pastInspctnDtls.length">
                            No Records to display
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal" tabindex="-1" id="viewDocModal">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Upload Files List</h5>
          <button type="button" class="btn-close" id="viewfileClose" data-bs-dismiss="modal" aria-label="Close"
            (click)="viewDocLst = []"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xl-12">
              <div *ngIf="viewDocLst.length" class="table-responsive">
                <table id="doclst" datatable class="table-striped table-bordered mt-2 pt-2 table-sm small"
                  style="width: 100%; white-space: nowrap">
                  <thead class="top">
                    <tr>
                      <th>Document Name</th>
                      <th>Inspection Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let s of viewDocLst">
                      <!-- <td>{{s.}}</td> -->
                      <td>{{ extractCleanFileName(s.upload_file.split('/').pop() || '') }}</td>
                      <td>{{ s.CREATED_ON | date : "dd-MM-yyyy" }}</td>
                      <td>
                        <a class="btn btn-sm btn-primary" [href]="videoUrl + s?.upload_file" target="_blank"
                          rel="noopener">
                          View
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" id="viewfileClose" data-bs-dismiss="modal"
            (click)="viewDocLst = []">
            Close
          </button>
          <!-- <button class="btn btn-save" (click)="submitQaso(approveData, 'u')">Submit</button>  -->
        </div>
      </div>
    </div>
</div>